export default __webpack_public_path__ + "static/media/ActiveSubTabIcon.55d287bd.svg";